import styled from 'styled-components';

const FieldWrapper = styled.div`
  margin-top: 22px;
  margin-bottom: 16px;
`;

export default FieldWrapper;
